import React from 'react'
import { TextField as MuiTextField } from '@mui/material'

interface ITextFieldProps {
  label?: string
  value?: string
  variant?: 'standard' | 'filled' | 'outlined'
  onChange?: (event: any) => void
  multiline?: boolean
  minRows?: number
  size?: 'small' | 'medium'
  margin?: 'none' | 'dense' | 'normal'
  fullWidth?: boolean
}

const TextField: React.FC<ITextFieldProps> = (props) => {
  return (
    <MuiTextField
      value={props.value}
      label={props.label}
      variant='outlined'
      multiline={props.multiline}
      minRows={props.minRows}
      size={props.size}
      margin={props.margin}
      fullWidth={props.fullWidth}
      onChange={(event) => props.onChange && props.onChange(event)}
    />
  )
}
export default TextField
